export const searchExpenseTypeEntry = async (searchValue, dataHouse) => {
    if (searchValue.trim() === '') {
        // If the search term is empty, return the whole array
        return dataHouse;
    }
    const searchData = await dataHouse.filter((data) => {
        return (data.expense_type.toLowerCase().includes(searchValue.toLowerCase()) ||
            Number(data.id) === Number(searchValue));
    });
    return searchData;
};